const closeMobileNav = () => {
	$('.header__navigation-overlay').on('click', function(event) {
		$('.header__navigation').removeClass('is-open');

		event.preventDefault();
	});
}

closeMobileNav();
